import { isSSR } from './isSSR';

const OD_RAF_CODE_COOKIE = 'odc-raf-code';

export const applyRafCode = (code: string) => {
  if (!isSSR()) window.localStorage.setItem(OD_RAF_CODE_COOKIE, code);
};

export const getAppliedRafCode = () => {
  return isSSR() ? undefined : window.localStorage.getItem(OD_RAF_CODE_COOKIE) || undefined;
};

export const clearAppliedRafCode = () => {
  if (!isSSR()) window.localStorage.removeItem(OD_RAF_CODE_COOKIE);
};
